import React from 'react';
import './App.css';
import AppContainer from "./components/AppContainer";
import {Outlet} from "react-router-dom";


const App = () => {

  return (
      <AppContainer>
        <Outlet/>
      </AppContainer>
  );
}

export default App;
